import { render } from "./ForgotPassword.vue?vue&type=template&id=15eb51a6"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
script.render = render

export default script